import BaseElement from './BaseElement';
import HealthscoreHistory from '../Components/Profile/HealthscoreHistory';
class HealthscoreHistoryElement extends BaseElement {
    constructor() {
        super(...arguments);
        this.element = HealthscoreHistory;
    }
}
export const loadHealthscoreHistoryElement = () => {
    customElements.define('healthscore-history', HealthscoreHistoryElement);
};
